import { useAppStore } from '@/core/stores/appStore';

/** Reactive ADHA journey flag (persisted). Prefer this over ENABLE_ADHA_JOURNEY. */
export function useIsAdhaJourney(): boolean {
  return useAppStore((state) => state.isAdhaJourney);
}

/** Non-hook read for services / guards outside React. */
export function getIsAdhaJourney(): boolean {
  return useAppStore.getState().isAdhaJourney;
}
